import { FC } from 'react';
import type { Goal } from '@teachur/http-client';
import { StarRating } from '@new/common/ui/StarRating/StarRating';

interface GoalReviewItemProps {
  goal: Goal;
  rating: number;
  note: string;
  disabled?: boolean;
  readonly?: boolean;
  onRatingChange?: (goalId: number, value: number) => void;
  onNoteChange?: (goalId: number, value: string) => void;
}

export const GoalReviewItem: FC<GoalReviewItemProps> = ({
  goal,
  rating,
  note,
  disabled,
  readonly,
  onRatingChange,
  onNoteChange,
}) => {
  const isBelow5 = !readonly && rating > 0 && rating < 5 && !note;

  return (
    <div
      className={`flex flex-col gap-2.5 rounded-[12px] border p-3 ${
        isBelow5 ? 'border-(--danger-D700)' : 'border-(--neutral-white-NW800)'
      }`}
    >
      <div className="flex items-start gap-3">
        <p className="m-0! [font-size:var(--fs-l5)]! font-medium leading-[150%] text-(--neutral-black-NB900)!">
          {goal.text}
        </p>

        <StarRating
          value={rating}
          disabled={disabled || readonly}
          onChange={(value) => onRatingChange?.(goal.id, value)}
        />
      </div>

      {readonly ? (
        note ? (
          <p className="m-0! [font-size:var(--fs-p5)]! text-(--neutral-black-NB700)!">{note}</p>
        ) : null
      ) : (
        <textarea
          value={note}
          disabled={disabled}
          onChange={(event) => onNoteChange?.(goal.id, event.target.value)}
          placeholder={
            isBelow5
              ? 'Required: Explain why this goal is rated below 5 stars'
              : 'Add note (optional)...'
          }
          className={`min-h-17 w-full border! bg-(--neutral-black-NB100) text-(--neutral-black-NB700) placeholder:text-(--neutral-black-NB500) rounded-[10px]! px-3 py-3 resize-none! ${
            isBelow5 ? 'border-(--danger-D700)!' : 'border-(--neutral-white-NW800)!'
          }`}
        />
      )}
    </div>
  );
};
